import React from 'react'
import { ProductLayout } from '../components/product-layout/ProductLayout'
import '../styles/pages/index.scss'

const TermsPage = () => (
  <ProductLayout productName="">
    <a
      className="la-breadcrumbs-pdf nx-lightweight-btn la-terms-pdf-button"
      href={`/pdf/LiveAction_Combined_License_Agreement_2212.pdf`}
      download
    >
      Download PDF
    </a>
    <div id="ww703345" className={'Title'}>
      LIVEACTION, INC. <br />
      SOFTWARE LICENSE &amp; MAINTENANCE AGREEMENT <br />
      LAST UPDATE: DECEMBER 2022
    </div>
    <div id="ww703348" className={'Body'}>
      BY ACCEPTING THIS AGREEMENT, EITHER BY INDICATING YOUR ACCEPTANCE, BY EXECUTING A QUOTE OR
      ORDERING DOCUMENT DIRECTLY WITH US OR WITH AN AUTHORIZED RESELLER (HOWEVER TITLED, REFERRED TO
      HEREIN AS AN “<u>ORDER</u>”) THAT REFERENCES THIS AGREEMENT, OR BY DOWNLOADING, INSTALLING
      AND/OR UTILIZING THE SERVICES (DEFINED BELOW), YOU AGREE TO THIS AGREEMENT. THIS AGREEMENT IS
      A LEGALLY BINDING CONTRACT BETWEEN YOU AND LIVEACTION, INC. AND SETS FORTH THE TERMS THAT
      GOVERN THE LICENSE PROVIDED TO YOU HEREUNDER. IF YOU ARE ENTERING INTO THIS AGREEMENT ON
      BEHALF OF A COMPANY OR OTHER LEGAL ENTITY, YOU REPRESENT THAT YOU HAVE THE AUTHORITY TO BIND
      SUCH ENTITY TO THIS AGREEMENT. ANY CHANGES, ADDITIONS OR DELETIONS BY YOU TO THIS AGREEMENT
      WILL NOT BE ACCEPTED AND WILL NOT BE A PART OF THIS AGREEMENT. IF YOU DO NOT AGREE TO THIS
      AGREEMENT, YOU MUST NOT DOWNLOAD, INSTALL, OR USE THE SERVICES.
    </div>
    <div id="ww703349" className={'Body'}>
      This Software License &amp; Maintenance Agreement (this “<u>Agreement</u>”) is entered into by
      and between LiveAction, Inc., with an address at 960 San Antonio Road, Suite 200, Palo Alto,
      CA, 94303 (“<u>LiveAction</u>”), and you or the entity on whose behalf you are entering into
      this Agreement, as applicable (“<u>You</u>”). LiveAction offers evaluation licenses (“
      <u>Evaluation License</u>”), ThreatEye Software-as-a-Service subscription license (“
      <u>SaaS License</u>”), perpetual licenses for on-premises installed software (“
      <u>Perpetual On-Prem License</u>”) and subscription licenses for on-premises installed
      software (“<u>Subscription On-Prem License</u>”) to its customers. LiveAction&apos;s
      on-premises, installed software shall be referred to as the “<u>On-Prem Software</u>”;
      LiveAction&apos;s ThreatEye Software-as-a-Service software shall be referred to as the “
      <u>SaaS Software</u>”; and the On-Prem Software and SaaS Software shall be collectively
      referred to as the “<u>Software</u>”.
    </div>
    <div id="ww703350" className={'Body'}>
      This Agreement governs Your use of the any version of Software provided or made available to
      You previously, concurrently or hereafter, any hardware purchased by You in connection with
      the Software (the “<u>Hardware</u>”), any user manuals, instructions or other documentation
      (collectively, “<u>Documentation</u>”) provided to You or made available by LiveAction for
      download through its website in connection with the Software, and any support, implementation
      or other professional services, including training (“<u>Professional Services</u>”). The
      Software, Hardware, Documentation and Professional Services are collectively referred to as
      the “<u>Services</u>”.{' '}
    </div>
    <div id="ww703351" className={'Step1'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>1. </span>
      </span>
      DESCRIPTION OF LICENSES AND SERVICES. Your Order will identify whether You have a Subscription
      On-Prem License, a Perpetual On-Prem License or a SaaS License.
    </div>
    <div id="ww703352" className={'StepAlpha1'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>a. </span>
      </span>
      <u>If You have ordered a Subscription On-Prem License:</u> Subject to Your continued
      compliance with the terms of this Agreement, including without limitation Your timely payment
      of all applicable Fees (as defined below), LiveAction grants You a limited, non-transferable,
      non-exclusive, non-sublicensable, non-assignable (except as expressly set forth below),
      revocable subscription license to install and use the On-Prem Software on one or more hardware
      platforms during the term of this Agreement. The Subscription On-Prem License begins at the
      time LiveAction delivers Your license key to You (other than on an evaluation basis) in
      response to an Order by You and thereafter continues in effect until the date of termination
      as set forth in this Agreement, in particular and without limitation Sections 10 and 11. Fees
      are non-refundable if You cancel Your Subscription On-Prem License or the Subscription On-Prem
      License is terminated by LiveAction for cause. All Subscription On-Prem licenses granted
      hereunder shall be term licenses for the term set forth in the relevant Order.
    </div>
    <div id="ww703353" className={'StepAlpha1'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>b. </span>
      </span>
      <u>If You have ordered a Perpetual On-Prem License:</u> Subject to Your continued compliance
      with the terms of this Agreement, including without limitation Your timely payment of all
      applicable Fees (as defined below), LiveAction grants You a non-exclusive, non-transferable,
      non-sublicensable, non-assignable (except as expressly set forth below), fully paid-up and
      perpetual (subject to termination as set forth herein) license to install and use the On-Prem
      Software on one or more hardware platforms during the term of this Agreement. Your Perpetual
      On-Prem License begins at the time LiveAction delivers Your license key to You (other than on
      an evaluation basis) in response to an Order by You and thereafter continues in effect until
      the date of termination as set forth in this Agreement, in particular and without limitation
      Section 10. Fees are non-refundable if the license is terminated by LiveAction for cause.
    </div>
    <div id="ww703354" className={'StepAlpha1'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>c. </span>
      </span>
      You may request to change Your license type from Perpetual On-Prem License to Subscription
      On-Prem License by submitting an amended Order specifying your request to LiveAction.
      LiveAction shall be free to accept or reject Your request in its sole discretion. If accepted,
      You shall pay to LiveAction or the respective authorized LiveAction reseller (as applicable)
      all applicable unpaid license/subscription Fees and Your new Subscription On-Prem License
      shall begin and terminate as described above.{' '}
    </div>
    <div id="ww703356" className={'StepAlpha1'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>d. </span>
      </span>
      <u>If You have ordered a SaaS License:</u>{' '}
    </div>
    <div id="ww703357" className={'StepAlphai'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>i. </span>
      </span>
      Subject to Your continued compliance with the terms of this Agreement, including without
      limitation Your timely payment of all applicable Fees (as defined below), LiveAction grants
      You a limited, non-transferable, non-exclusive, non-sublicensable, non-assignable (except as
      expressly set forth below), revocable license to access and use the SaaS Software for Your
      internal business purposes and in accordance with the subscribed volume set forth on the Order
      (“<u>Subscribed Volume</u>”). The SaaS License begins at the time LiveAction delivers logon
      credentials (other than on a trial basis) in response to an Order by You and thereafter
      continues in effect until the date of termination as set forth in this Agreement, in
      particular and without limitation Sections 10 and 11. Fees are non-refundable if You cancel
      Your SaaS License or the SaaS License is terminated by LiveAction for cause. All SaaS Licenses
      granted hereunder shall be term licenses for the term set forth in the relevant Order. If
      during a SaaS License term You exceed the Subscribed Volume, the provisions set forth on
      Exhibit C attached hereto shall apply, and in the event of an Over-Subscribed Situation (as
      defined on Exhibit C), the covenants, representations and warranties in this Agreement
      regarding the provision of the Services, including without limitation the Service Level
      Agreement, shall not apply.
    </div>
    <div id="ww703358" className={'StepAlphai'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>ii. </span>
      </span>
      LiveAction will provide the SaaS Software in a manner consistent with technology industry
      standards, which includes reasonable service interruptions due to scheduled maintenance,
      unscheduled emergency maintenance, or because of other causes beyond LiveAction&apos;s
      reasonable control. LiveAction&apos;s Service Level Agreement is set forth on Exhibit D
      attached hereto.
    </div>
    <div id="ww703359" className={'StepAlphai'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>iii. </span>
      </span>
      “Your Data” means all data, information or material that You submit to the SaaS Software. You
      represent and warrant that: (A) You own or otherwise have and will have the necessary rights
      and consents in and relating to Your Data, and (B) You will not knowingly introduce into the
      SaaS Software any viruses or other harmful code. You are solely responsible for the accuracy,
      integrity, legality, reliability and appropriateness of Your Data. You further acknowledge
      that LiveAction does not provide or undertake backup or maintenance services for Your Data,
      and You shall be solely responsible for backup of all Your Data. You hereby grant to
      LiveAction a non-exclusive, worldwide, royalty-free, fully paid-up, perpetual and irrevocable
      license during the term and thereafter to use Your Data that has been anonymized and
      aggregated with anonymized data of other LiveAction customers (“Anonymous Data”) in order to
      improve and enhance the Software. For clarity, Anonymous Data shall not be identifiable to any
      customer or to any user.
    </div>
    <div id="ww703360" className={'StepAlphai'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>iv. </span>
      </span>
      Each Party has obligations with respect to the security of the SaaS Software and Your Data.
      Taking into account the nature and types of Your Data, LiveAction will employ reasonable
      administrative, physical and technical measures in accordance with applicable industry
      practice, including Soc II Type 2 certification, to protect the SaaS Software and prevent the
      accidental loss or unauthorized access, use, alteration or disclosure of Your Data under its
      control during the Term.{' '}
    </div>
    <div id="ww703361" className={'StepAlphai'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>v. </span>
      </span>
      The Data Processing Addendum located at trustcenter.liveaction.com (“DPA”) accompanies this
      Agreement and sets forth other terms of our agreement that apply to the extent any information
      You provide to LiveAction via Your use of the SaaS Software for processing by LiveAction
      includes “personal data” or “personal information” or like term under applicable law;
      provided, however, that the DPA shall not apply to personal data that LiveAction processes as
      a controller, including with respect to the personal data of Your Contacts (as defined below).
      “<u>Your Contacts</u>” means the name and contact information of those of Your employees who
      are the business contacts responsible for interacting with LiveAction in connection with our
      business relationship.{' '}
    </div>
    <div id="ww703362" className={'StepAlphai'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>vi. </span>
      </span>
      The SaaS Software retains Your Data for a period of one year (the “<u>Retention Period</u>
      <b>”</b>) on a daily rolling basis (i.e., Your Data will be erased at the end of the Storage
      Period, and new data will be stored in its place), so that at any time during the SaaS License
      term, Your Data derived by the SaaS Service for the most recent Retention Period may be
      searchable by You; please see the applicable provisions in the SaaS Software user guide for
      limitations.
    </div>
    <div id="ww703363" className={'StepAlpha1'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>e. </span>
      </span>
      As used herein, “hardware platform” means the computer server(s), desktop computer(s), laptop
      computer(s), appliance(s), or virtual machine(s) determined by the configuration You chose
      when ordering Software or downloading the On-Prem Software at or from LiveAction&apos;s
      website. You may not make any copies of the Software and Documentation except that You may
      make one copy of On-Prem Software that You may use solely for backup and recovery purposes.{' '}
    </div>
    <div id="ww703365" className={'StepAlpha1'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>f. </span>
      </span>
      <u>If You have been provided an Evaluation License for either On-Prem or SaaS Software</u>:
      The Evaluation License Terms set forth on Exhibit B shall apply for the term of the Evaluation
      License. In the event of any conflict between a provision on Exhibit B and a provision in the
      main body of this Agreement, the provision on Exhibit B shall control for the term of the
      Evaluation License.
    </div>
    <div id="ww703367" className={'StepAlpha1'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>g. </span>
      </span>
      Unless subject to a separate agreement by the parties, LiveAction&apos;s provision of
      Professional Services shall be as agreed by the parties in an Order, which Order shall
      describe the scope of such Professional Services and shall become a part of and shall be
      subject to the terms of this Agreement.
    </div>
    <div id="ww703368" className={'Step'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>2. </span>
      </span>
      RESTRICTIONS ON USE. You shall not, and shall not permit or encourage any third party to: (a)
      alter, modify, adapt, translate, reverse engineer, disassemble, decompile, or attempt to
      derive the source code of the Software or any part thereof, except to the extent that such
      activities are permitted under applicable law; (b) sell, lease, rent, sublicense, redistribute
      or otherwise transfer or convey the Services to any third party; (c) use the Services for any
      time-sharing, outsourcing, service bureau, hosting, application service provider or like
      purposes; (d) remove, alter, or obscure in any way the proprietary rights notices (including
      copyright, patent, and trademark notices and symbols) of LiveAction or its suppliers contained
      on or within any copies of the Software or Documentation; (e) use the Services other than as
      described in the applicable Documentation, or with any unsupported software or hardware (as
      described in the applicable Documentation); (f) disclose the results of any benchmark tests on
      the Services without LiveAction&apos;s prior written consent; or (g) use the Services for any
      unlawful purpose. Any violation of any of the foregoing restrictions shall be a material
      breach of this Agreement.{' '}
    </div>
    <div id="ww703369" className={'Step'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>3. </span>
      </span>
      HARDWARE. If included in Your Order and subject to the terms of this Agreement, LiveAction
      will sell the Hardware to You for use in connection with Software. Title and all risk with
      respect to the Hardware will pass to You upon shipment by LiveAction. In the event that the
      Hardware includes or incorporates any software code (including without limitation any
      firmware, operating system or other software), such software code shall be deemed “Software”
      licensed to You solely under the terms of this Agreement except as expressly provided below.
      LiveAction&apos;s obligations with respect to the support and maintenance services set forth
      in Section 7 shall be subject to all use of the Hardware by You being solely in connection
      with the Software and in the technical configuration specified by LiveAction. Notwithstanding
      anything to the contrary contained herein, all Fees (as defined below) for Hardware are
      nonrefundable and non-cancellable, and in no event shall You be entitled to any refund,
      partial or otherwise, of Fees paid for Hardware, regardless of any termination of this
      Agreement.{' '}
    </div>
    <div id="ww703370" className={'Step'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>4. </span>
      </span>
      OWNERSHIP; RESERVATION OF RIGHTS.{' '}
    </div>
    <div id="ww703371" className={'StepAlpha1'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>a. </span>
      </span>
      LiveAction and its licensors or suppliers own and retain all right, title and interest,
      including all copyrights, patents, trade secret rights, trademarks, and other intellectual
      property rights, in and to the Services and any improvements, modifications, or enhancements
      thereto. All copies of the Software and Documentation provided or made available to You are
      licensed, not sold. Except as expressly provided herein, this Agreement does not grant You any
      rights under LiveAction&apos;s or its licensor&apos;s patents, copyrights, trade secrets,
      trademarks or other intellectual property rights, and all rights not expressly provided to You
      hereunder are reserved by LiveAction and its licensors. The LiveAction name, the LiveAction
      logos, the marks of LiveAction&apos;s affiliates and licensors, and the product names
      associated with the Software are trademarks of LiveAction or third parties, and no right or
      license is granted to use them.
    </div>
    <div id="ww703372" className={'StepAlpha1'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>b. </span>
      </span>
      LiveAction reserves the right to discontinue or materially modify the Software at any time in
      its sole discretion with 90 days&apos; prior written notice to You; provided, however, that
      LiveAction will continue to provide the Software for the remainder of Your unexpired term or
      work with You to migrate to another generally available LiveAction offering.{' '}
    </div>
    <div id="ww703373" className={'Step'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>5. </span>
      </span>
      FEES; PAYMENT. You agree to pay to LiveAction or the respective authorized LiveAction reseller
      (as applicable) all applicable license fees (“License Fees”) and maintenance fees
      (“Maintenance Fees”) set forth in LiveAction&apos;s Quote, or as mutually agreed in writing
      between You and LiveAction or as agreed between an authorized LiveAction reseller on Your
      behalf and LiveAction (collectively, “<u>Fees</u>”). LiveAction will invoice You in advance
      for all applicable Fees at the billing address You provided to LiveAction at the time of
      ordering the Services or at any later time. Each invoice shall be payable within 30 days of
      invoice date, and late amounts shall accrue 1.5% interest per month. All Fees are
      non-refundable, and denominated and payable in United States dollars. All Fees are exclusive
      of any taxes (whether personal or sales), tariffs, duties or similar charges of any kind
      arising out of this Agreement other than taxes on LiveAction&apos;s net income (collectively,
      “<u>Taxes</u>”), and any applicable Taxes are Your sole responsibility. The Fees set forth in
      a Quote or Order are fixed for the term set forth therein; provided that LiveAction may
      increase the License Fees and/or the Maintenance Fees upon any renewal term, including without
      limitation any automatic renewal agreed by the parties in an Order pursuant to Section 10 of
      this Agreement and the provision entitled “Term” on Exhibit A, provided that LiveAction will
      provide You with written notice of any such Fee increase at least sixty (60) days prior to the
      end of the applicable term.{' '}
    </div>
    <div id="ww703374" className={'Step'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>6. </span>
      </span>
      RECORDS AND AUDIT. You shall establish and maintain complete and accurate records related to
      Your access and use of the Services, and any such other information as reasonably necessary
      for LiveAction to verify Your compliance with the terms of this Agreement. Upon prior notice,
      LiveAction or its representative may inspect such records to confirm Your compliance with the
      terms of this Agreement.{' '}
    </div>
    <div id="ww703375" className={'Step'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>7. </span>
      </span>
      SUPPORT AND MAINTENANCE. Subject to Your continued compliance with the terms of this
      Agreement, LiveAction will provide You with support and maintenance services related to the
      Software and Hardware in accordance with the LiveAction Maintenance Program Terms &amp;
      Conditions attached hereto as Exhibit A (the “<u>Maintenance Program Terms</u>”), during the
      applicable Maintenance Term (as defined in the Maintenance Program Terms). The Maintenance
      Program Terms are incorporated herein by reference. Upon being provided to You by LiveAction
      hereunder, any Maintenance Revisions (as defined in the Maintenance Program Terms) shall be
      considered part of the Software and subject to the terms and conditions of this Agreement. For
      On-Prem Software: (a) You must install such Maintenance Revisions as soon as practicable after
      receipt and in accordance with LiveAction&apos;s instructions; (b) You acknowledge and agree
      that any failure to install Maintenance Revisions may limit LiveAction&apos;s ability to
      provide You with maintenance and support and may limit the functionality, performance and/or
      operation of the Software; and (c) all support and maintenance services will be provided only
      with respect to the two most recent versions of the Software.
    </div>
    <div id="ww703376" className={'Step'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>8. </span>
      </span>
      FEEDBACK. Any feedback, comments, suggestions, bug reports, log files, or other information
      provided by You to LiveAction related to or in connection with the Services (“<u>Feedback</u>
      ”) shall be provided on a non-confidential basis (notwithstanding any notice to the contrary
      You may include in any accompanying communication), and LiveAction may use such Feedback for
      any business purposes without restriction, including without limitation for product
      development and support. You hereby grant LiveAction a perpetual, irrevocable, nonexclusive
      license under all rights necessary to incorporate and use such Feedback for any purpose.
    </div>
    <div id="ww703377" className={'Step'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>9. </span>
      </span>
      CONFIDENTIALITY.{' '}
    </div>
    <div id="ww703378" className={'StepAlpha1'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>a. </span>
      </span>
      Each party acknowledges that the other party treats its products, development processes,
      business methods, business information, and prices as confidential and that they constitute
      the commercially valuable proprietary products and/or services and trade secrets of the
      respective party, regardless of whether they may be copyrighted, patented or trademarked.
    </div>
    <div id="ww703379" className={'StepAlpha1'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>b. </span>
      </span>
      During the term of this Agreement, each party (the “Receiving Party”) will learn or receive
      information about the other (the “Disclosing Party”) which the Disclosing Party treats as
      confidential, including but not limited to all business, technical, marketing, financial and
      customer-related data (“Confidential Information”). For the avoidance of doubt, the Software
      and Documentation are the Confidential Information of LiveAction. The Receiving Party agrees
      that Confidential Information received from the Disclosing Party shall be treated as
      confidential and protected in the same manner as the Receiving Party treats its own
      confidential information (but in no event less than reasonable care). The Receiving Party
      agrees: (i) not to use any Confidential Information of the Disclosing Party for any purpose
      other than exercising its rights and fulfilling its obligations hereunder; (ii) not to
      transfer, distribute or disclose to any third party any Confidential Information of the
      Disclosing Party, except as expressly authorized in writing by the Dislosing Party; (iii) not
      to reverse engineer, disassemble, decompile or design around the Disclosing Party&apos;s
      Confidential Information; (iv) to not remove or obscure any designations of confidentiality on
      any Confidential Information; and (v) to confine knowledge and use of the Confidential
      Information received from the Disclosing Party to those of its employees and contractors who
      require such knowledge and use of the information in the ordinary course of and scope of their
      employment pursuant to this Agreement. Notwithstanding the foregoing, Confidential Information
      shall not include information which has entered the public domain by no action of the
      Receiving Party hereunder, was already rightfully in the possession of the Receiving Party
      when received from the Disclosing Party, is received from a third party without breach of any
      obligation owed to the Disclosing Party or was developed independently by the Receiving Party
      by individuals without access to the Disclosing Party&apos;s information.
    </div>
    <div id="ww703380" className={'StepAlpha1'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>c. </span>
      </span>
      The Receiving Party may disclose Confidential Information of the Disclosing Party if it is
      compelled by law to do so, provided the Receiving Party gives the Disclosing Party prior
      notice of such compelled disclosure (to the extent legally permitted) and reasonable
      assistance, at the Disclosing Party&apos;s cost, if the Disclosing Party wishes to contest the
      disclosure. If the Receiving Party is compelled by law to disclose the Disclosing Party&apos;s
      Confidential Information as part of a civil proceeding to which the Disclosing Party is a
      party, and the Disclosing Party is not contesting the disclosure, the Disclosing Party will
      reimburse the Receiving Party for its reasonable cost of compiling and providing secure access
      to such Confidential Information.
    </div>
    <div id="ww703381" className={'StepAlpha1'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>d. </span>
      </span>
      The obligations of the parties, with regard to the Confidential Information of the other that
      constitutes trade secrets, shall remain in effect for as long as such Confidential Information
      shall remain a trade secret under applicable law. All other Confidential Information shall
      remain protected during the term of this Agreement and for three (3) years thereafter.
    </div>
    <div id="ww703382" className={'StepAlpha1'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>e. </span>
      </span>
      Each of You and LiveAction acknowledge that the damages for unauthorized and/or improper
      disclosure of the Confidential Information of the Disclosing Party may be irreparable;
      therefore, the parties may seek equitable relief, including injunction and preliminary
      injunction for such alleged breaches.
    </div>
    <div id="ww703383" className={'StepAlpha1'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>f. </span>
      </span>
      Upon any termination of this Agreement or the parties&apos; working relationship, and all
      Confidential Information shall be returned to the Disclosing Party or, at the Disclosing
      Party&apos;s option, destroyed. Upon request the Receiving Party shall confirm to the
      Disclosing Party in writing that all such Confidential Information has been fully returned or
      destroyed in compliance herewith. Notwithstanding the foregoing, the Receiving Party shall not
      be required to purge its back-up systems of Confidential Information and the Receiving Party
      may retain necessary Confidential Information for legal and evidentiary purposes, provided
      such Confidential Information remains subject to the confidentiality and is destroyed in the
      normal process of the Receiving Party reasonable record retention policies and procedures.{' '}
    </div>
    <div id="ww703385" className={'Step'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>10. </span>
      </span>
      TERM OF SAAS LICENSES AND SUBSCRIPTION ON-PREM LICENSES. The initial term of this Agreement
      and Your license term for Subscription On-Prem Software and/or SaaS Software will continue
      until the end of the subscription period You have purchased, unless this Agreement is
      terminated earlier in accordance with its terms (the “<u>Initial Term</u>”). Upon expiration
      of the Initial Term, unless the parties agree to auto-renewal in an Order, Your license term
      will renew for additional successive terms upon the mutual written agreement of the parties
      (each a “<u>Renewal Term</u>”). Notwithstanding the length of the license term, the maximum
      term for maintenance and support of Hardware is five (5) years.
    </div>
    <div id="ww703387" className={'Step'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>11. </span>
      </span>
      TERMINATION. This Agreement and the licenses granted to You hereunder terminate immediately if
      You violate any of the terms or conditions of this Agreement. LiveAction may also terminate
      this Agreement if You (i) terminate or suspend Your business, (ii) become insolvent or unable
      to pay Your debts as they mature, make an assignment for the benefit of creditors, or become
      subject to direct control of a trustee, receiver or similar authority, or (iii) become subject
      to any bankruptcy or insolvency proceeding under federal or state statutes. In the event of
      any expiration or termination of this Agreement, all licenses granted hereunder terminate
      immediately and (a) You must immediately cease using the Software and remove all On-Prem
      Software from the hardware platform on which You installed it, and (b) destroy any copies of
      the Software and Documentation in Your possession or control, or return all such copies to
      LiveAction at the address written above. Should You choose to destroy the On-Prem Software
      and/or Documentation, You hereby agree to provide written certification of such destruction
      upon LiveAction&apos;s request. Termination of this Agreement shall not prevent LiveAction or
      its licensors from claiming any further damages. Sections 4, 5, 6, 8, 9, 11, 13, 14, and 16
      through 26 shall survive any termination or expiration of this Agreement.
    </div>
    <div id="ww703388" className={'Step'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>12. </span>
      </span>
      LIMITED WARRANTY. LiveAction warrants, for a period of 90 days from the date You first
      downloaded the On-Prem Software or accessed the SaaS Software (the &quot;
      <u>Warranty Period</u>&quot;), that (i) the Software will operate substantially in accordance
      with the applicable Documentation and (ii) the media on which the On-Prem Software and
      Documentation is distributed, if any, will be free from material defects in materials and
      workmanship. The foregoing warranties shall apply only if (a) the Software has been properly
      installed (as applicable) and used at all times and in accordance with the applicable
      Documentation; and (b) no modification, alteration or addition has been made to the Software
      by persons other than LiveAction or its authorized representative(s). For the avoidance of
      doubt, the foregoing warranties are not made with respect to an Evaluation Version of Software
      or any Software offered under an Evaluation License. In the event of a breach of the foregoing
      warranties, You may contact LiveAction for repair or replacement of the Software, or a refund
      of the License Fees paid by You under this Agreement, at the sole discretion of LiveAction.
      Any replacement Software provided by LiveAction will be warranted for the remainder of the
      original warranty period. If You have purchased a SaaS License, the limited warranty
      provisions of this Section 12 shall also apply to the Hardware, if any.{' '}
      <b>
        THE FOREGOING IS YOUR SOLE AND EXCLUSIVE REMEDY, AND LIVEACTION&apos;S SOLE AND EXCLUSIVE
        LIABILITY, FOR BREACH OF ANY OF LIVEACTION&apos;S WARRANTIES REGARDING THE SERVICES SET
        FORTH IN THIS AGREEMENT.
      </b>
    </div>
    <div id="ww703389" className={'Step'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>13. </span>
      </span>
      WARRANTY DISCLAIMER. TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, THE WARRANTIES
      EXPRESSLY STATED HEREIN ARE EXCLUSIVE AND IN LIEU OF ALL OTHER WARRANTIES. OTHER THAN AS
      EXPRESSLY SET FORTH ABOVE, THE SERVICES ARE PROVIDED AS IS AND LIVEACTION AND ITS RESELLERS,
      SUPPLIERS AND LICENSORS DISCLAIM ALL OTHER WARRANTIES, WHETHER EXPRESS, IMPLIED, STATUTORY OR
      OTHERWISE, INCLUDING BUT NOT LIMITED TO THE IMPLIED WARRANTIES OF TITLE, UNINTERRUPTED USE,
      MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE OR NONINFRINGEMENT. NEITHER LIVEACTION NOR
      ITS RESELLERS, SUPPLIERS OR LICENSORS WARRANT THAT THE SERVICES WILL BE FREE FROM ERRORS, WILL
      MEET YOUR PARTICULAR NEEDS, WILL BE FREE FROM BUGS, THAT USE OF THE SERVICES WILL BE
      UNINTERRUPTED, OR THAT ANY ERRORS OR BUGS WILL BE CORRECTED. YOU ASSUME FULL RESPONSIBILITY
      FOR THE SELECTION OF THE SERVICES TO ACHIEVE YOUR INTENDED RESULTS AND FOR THE INSTALLATION
      (AS APPLICABLE), USE AND RESULTS OBTAINED THEREFROM. YOU UNDERSTAND THAT: (A) ANY OUTCOME OF
      THE USE OF THE SERVICES IS LIMITED TO A POINT-IN-TIME EXAMINATION OF YOUR DATA; AND (B) THE
      SERVICES DO NOT CONSTITUTE ANY FORM OF REPRESENTATION, WARRANTY OR GUARANTEE THAT YOUR SYSTEMS
      ARE SECURE FROM EVERY FORM OF ATTACK. YOU UNDERSTAND AND ACKNOWLEDGE THAT NOT ALL ANOMALIES OR
      INTRUSIONS MAY BE REPORTED OR PREVENTED. WITHOUT LIMITING THE FOREGOING, LIVEACTION, ITS
      RESELLERS, SUPPLIERS AND LICENSORS SPECIFICALLY DISCLAIM ALL LIABILITY IN CONNECTION WITH USE
      OF THE SERVICES FOR, AND YOU AGREE NOT TO USE THE SERVICES FOR, ANY MEDICAL, LIFE-SAVING,
      AVIATION AND/OR NUCLEAR ACTIVITIES. THE FOREGOING PROVISIONS WILL BE ENFORCEABLE TO THE
      MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW. ALL OPEN-SOURCE COMPONENTS ARE PROVIDED &quot;AS
      IS&quot; AND WITHOUT WARRANTY OF ANY KIND.{' '}
    </div>
    <div id="ww703391" className={'Step'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>14. </span>
      </span>
      LIMITATION OF LIABILITY. TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT SHALL
      LIVEACTION, ITS RESELLERS, SUPPLIERS AND LICENSORS OR ITS AND THEIR RESPECTIVE OFFICERS,
      DIRECTORS, SHAREHOLDERS, MEMBERS, EMPLOYEES, AND AGENTS (COLLECTIVELY, THE “LIVEACTION
      PARTIES”) BE LIABLE FOR ANY SPECIAL, INCIDENTAL, INDIRECT, CONSEQUENTIAL OR PUNITIVE DAMAGES
      WHATSOEVER (INCLUDING, WITHOUT LIMITATION, DAMAGES FOR LOSS OF PROFITS, LOSS OF REVENUE, LOSS
      OF INFORMATION, LOSS OF DATA, LOSS OF GOODWILL, BUSINESS INTERRUPTION OR WORK STOPPAGE,
      COMPUTER FAILURE, MALFUNCTION, OR BUSINESS INTERRUPTION) ARISING OUT OF THE USE OF OR
      INABILITY TO USE THE SERVICES, INCLUDING FOR THE AVOIDANCE OF DOUBT ANY OPEN-SOURCE
      COMPONENTS, HARDWARE, DOCUMENTATION OR SERVICES, EVEN IF THE LIVEACTION PARTY(IES) HAS BEEN
      ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW,
      THE MAXIMUM CUMULATIVE LIABILITY, AND THE MAXIMUM CUMULATIVE REMEDY YOU MAY RECOVER FROM THE
      LIVEACTION PARTIES, SHALL BE LIMITED TO THE LICENSE FEES ACTUALLY PAID BY YOU TO LIVEACTION
      FOR THE SERVICES HEREUNDER IN THE TWELVE MONTHS PRECEDING THE EVENT GIVING RISE TO THE CLAIM.
      YOU ACKNOWLEDGE AND AGREE THAT, NOTWITHSTANDING THE FAILURE OF ESSENTIAL PURPOSE OF ANY
      LIMITED REMEDY PROVIDED HEREUNDER, LIVEACTION&apos;S PRICING OF ITS FEES UNDER THIS AGREEMENT
      REFLECTS THE FOREGOING ALLOCATION OF RISK AND LIMITATION OF LIABILITY UNDER THIS AGREEMENT.
    </div>
    <div id="ww703393" className={'Step'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>15. </span>
      </span>
      INTELLECTUAL PROPERTY INDEMNIFICATION. LiveAction will defend at its own expense any third
      party legal actions brought against You to the extent arising out of or resulting from claims
      that the Software infringes or violates any United States copyright of any third party during
      the term of this Agreement (“<u>Claim</u>”), on the condition that You promptly notify
      LiveAction of the Claim and give LiveAction sole and exclusive control of the defense and
      settlement of the Claim. You may not settle or compromise any Claim without LiveAction&apos;s
      prior written consent. If You are, or may become, legally prohibited from continued use of the
      Software by reason of an actual Claim, LiveAction will, at its sole option, (a) obtain for You
      the right to use the Software, (b) replace or modify such Software so that it is no longer
      subject to a Claim, but performs similar functions, or (c) immediately terminate this
      Agreement and refund to You the License Fees You have paid in respect of the Software.
      LiveAction will have no liability for any Claim based on or related to (i) the Evaluation
      Version, (ii) use of any other than the most recent release of the Software or failure to
      timely implement any Maintenance Revision or SaaS Software update made available to You by
      LiveAction, (iii) any use of the Software, modification of Software, or the combination of the
      Software with any other software that is not approved in writing by LiveAction, (iv) any
      Open-Source Components or other third party materials, (v) negligence, abuse, misapplication
      or misuse of the Software, Hardware or Documentation by You or on Your behalf or (vi) any
      copyright issued or application published after the effective date of this Agreement. THIS
      SECTION STATES LIVEACTION&apos;S SOLE AND EXCLUSIVE LIABILITY, AND YOUR SOLE AND EXCLUSIVE
      REMEDY, WITH RESPECT TO INFRINGEMENT OR MISAPPROPRIATION OF INTELLECTUAL PROPERTY RIGHTS OF
      ANY KIND.
    </div>
    <div id="ww703394" className={'Step'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>16. </span>
      </span>
      <b>
        USE INDEMNIFICATION. You hereby agree to defend, indemnify, and hold the LiveAction Parties
        harmless from and against any liability, loss, injury, damage, cost or expense (including
        reasonable attorneys&apos; fees) incurred by the LiveAction Parties arising out of or in
        connection with a third party claim arising from Your breach of this Agreement or Your use
        of the Services.
      </b>
    </div>
    <div id="ww703395" className={'Step'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>17. </span>
      </span>
      EQUITABLE REMEDIES. You hereby agree that LiveAction would be irreparably damaged if the terms
      of this Agreement were not specifically enforced, and therefore You agree that LiveAction
      shall be entitled, without bond, other security, or proof of damages, to appropriate equitable
      remedies with respect to breaches of this Agreement, in addition to such other remedies as
      LiveAction may otherwise have available to it under applicable laws. In the event any
      litigation is brought by either party in connection with this Agreement, the prevailing party
      in such litigation shall be entitled to recover from the other party all the costs,
      attorneys&apos; fees and other expenses incurred by such prevailing party in the litigation.
    </div>
    <div id="ww703396" className={'Step'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>18. </span>
      </span>
      ASSIGNMENT. Neither party may assign or transfer this Agreement without the prior written
      consent of the other party, provided that LiveAction may assign or otherwise transfer this
      Agreement without Your consent in connection with a corporate reorganization, merger,
      acquisition, sale of assets or stocks, or change of control of LiveAction.
    </div>
    <div id="ww703397" className={'Step'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>19. </span>
      </span>
      GOVERNING LAW; JURISDICTION. This Agreement shall be governed by, and interpreted in
      accordance with, the laws of the State of California, notwithstanding any conflicts of law
      provisions, and specifically excluding the provisions of the United Nations Convention on
      Contracts for the International Sale of Goods. All disputes arising out of or related to this
      Agreement will be subject to the exclusive jurisdiction of the state courts located in Santa
      Clara County, California, and the federal courts located in the Northern District of
      California, and the parties agree and submit to the personal and exclusive jurisdiction and
      venue of these courts.
    </div>
    <div id="ww703398" className={'Step'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>20. </span>
      </span>
      ENTIRE AGREEMENT. This Agreement constitutes the entire agreement and understanding between
      You and LiveAction regarding the subject matter herein. No change to this Agreement shall be
      binding upon LiveAction unless specifically agreed to in a written amendment to this Agreement
      signed by an authorized representative of LiveAction. However, in the case of any conflict,
      the terms of an executed Order shall take precedence over a provision in the body of this
      Agreement. Any terms and conditions of a purchase order or other ordering document for the
      Services (other than an executed Order that references this Agreement) shall not be binding
      upon and are specifically disclaimed by LiveAction, and this Agreement shall supersede any
      such terms. Notwithstanding the foregoing, in the event You have separately negotiated an
      agreement with LiveAction the terms and conditions of such negotiated agreement shall control
      over and supersede this Agreement.
    </div>
    <div id="ww703400" className={'Step'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>21. </span>
      </span>
      SEVERABILITY; WAIVER. If any provision of this Agreement is found to be illegal or
      unenforceable, such provision shall be reformed to the extent necessary to make it
      enforceable, and the remaining provisions of this Agreement shall continue to be valid and
      enforceable to the fullest extent permitted by law. The failure of either party to enforce its
      rights under this Agreement at any time for any period shall not be construed as a waiver of
      such rights.
    </div>
    <div id="ww703401" className={'Step'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>22. </span>
      </span>
      EXPORT CONTROLS. The Services and any technical data related to the Services may not be
      exported, reexported or used in any manner in violation of the laws, statutes, executive
      orders or regulations of the United States of America or of any country to which the Services
      have been legally exported or re-exported. You shall fully comply with all applicable United
      States and foreign export law, regulations and license restrictions relating to the Services.
      Without limiting the foregoing, the Services may not be downloaded or otherwise exported or
      re-exported (i) into (or to a national or resident of) any country to which the U.S. has
      embargoed goods; (ii) any end user known, or having reason to be known, will utilize them in
      the design, development or production of nuclear, chemical or biological weapons; or (iii) to
      anyone on the U.S. Treasury Department&apos;s list of Specially Designated Nationals or the
      U.S. Commerce Department&apos;s Table of Denial Orders. By downloading or using the Services,
      You are agreeing to the foregoing and You are representing and warranting that You are not
      located in, under the control of, or a national or resident of any such country or on any such
      list.
    </div>
    <div id="ww703402" className={'Step'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>23. </span>
      </span>
      U.S. GOVERNMENT RESTRICTED RIGHTS. The Software and Documentation, and any technical data
      related to the Software or Documentation, is a &quot;Commercial Item&quot; as that term is
      defined at 48 C.F.R. §2.101, consisting of “Commercial Computer Software” and “Commercial
      Computer Software Documentation,” as such terms are used in 48 C.F.R. §12.212 or 48 C.F.R.
      §227.7202, as applicable. If the end user of the Software is the U.S. Government or an agency
      or department thereof, the Software is only delivered as a Commercial Item subject to the
      license grant and the other terms and conditions set forth in this Agreement. Acquisition of
      the Software by the U.S. Government or an agency or department thereof shall only be under FAR
      or DFAR provisions for ACQUISITION OF COMMERCIAL ITEMS and any such acquisition shall not
      alter the grant or the terms and conditions of this Agreement.
    </div>
    <div id="ww703403" className={'Step'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>24. </span>
      </span>
      PRIVACY POLICY. Please refer to our privacy policy which can be found at{' '}
      <span className={'xref'}>
        <a href="https://www.liveaction.com/index.php/privacy-policy/" target="external_window">
          www.liveaction.com/index.php/privacy-policy/
        </a>
      </span>{' '}
      as amended by LiveAction from time to time, for information on how we collect, use and
      disclose information from our users.
    </div>
    <div id="ww703404" className={'Step'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>25. </span>
      </span>
      OPEN-SOURCE COMPONENTS. Certain third-party software tools included in or with the Software
      are open-source tools subject to open-source copyright license agreements (“
      <u>Open-Source Components</u>”). Open-Source Components are not provided by or warranted by
      LiveAction, and such Open-Source Components are excluded from any License Fees charged by
      LiveAction for any of its Services.{' '}
    </div>
    <div id="ww703405" className={'Step'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>26. </span>
      </span>
      INDEPENDENT PARTIES. The parties are independent contractors. No joint venture, partnership,
      employment, or agency relationship exists between You and LiveAction as a result of this
      Agreement or use of the Services.
    </div>
    <div id="ww704188" className={'Title'}>
      EXHIBIT A<br />
      LIVEACTION: MAINTENANCE PROGRAM TERMS &amp; CONDITIONS{' '}
    </div>
    <div id="ww703408" className={'Body'}>
      These Maintenance Program Terms govern the support and maintenance services provided by
      LiveAction to You under the Agreement. All support and maintenance services will be provided
      only with respect to the two most recent versions of the Software.{' '}
    </div>
    <div id="ww703409" className={'Body'}>
      <b>MAINTENANCE REVISIONS</b>
    </div>
    <div id="ww703410" className={'Body'}>
      “<u>Maintenance Revision</u>” means any update, upgrade, release or other adaptation or
      modification of the Software, including any updated Documentation, that LiveAction may provide
      to You from time to time, which may include, among other things, error corrections,
      enhancements, improvements or other changes to the user interface, functionality,
      compatibility, capabilities, performance, efficiency or quality of the Software, but does not
      include any New Version. A “<u>New Version</u>” means any version of the Software that
      LiveAction may from time to time introduce and market generally as a distinct licensed product
      (as may be indicated by LiveAction&apos;s designation of a new version number), and which
      LiveAction may make available to You at an additional cost under a separate license and
      maintenance agreement.{' '}
    </div>
    <div id="ww703411" className={'Body'}>
      <b>TERM</b>
    </div>
    <div id="ww703412" className={'Body'}>
      <b>For Subscription On-Prem Licenses and SaaS Licenses</b>
    </div>
    <div id="ww703413" className={'Body'}>
      The initial and any renewal term of these Maintenance Program Terms (“Maintenance Term”) will
      correspond to the Initial Term and any Renewal Term of Your Subscription On Prem License
      and/or SaaS License as provided in the Agreement, unless the Agreement is terminated earlier
      in accordance with its terms, including without limitation Your failure to pay
      LiveAction&apos;s then-current License Fees or Maintenance Fees when due. Notwithstanding the
      foregoing, for On-Prem Software, LiveAction may elect at any time to not renew these
      Maintenance Program Terms in the event LiveAction generally ceases providing support and
      maintenance services for the applicable Software to its customers. Notwithstanding the length
      of the license term, the maximum term for maintenance and support of Hardware is five (5)
      years.
    </div>
    <div id="ww703414" className={'Body'}>
      <b>For Perpetual On-Prem Licenses</b>
    </div>
    <div id="ww703415" className={'Body'}>
      If You have purchased a Perpetual On-Prem License, the initial term of these Maintenance
      Program Terms (“<u>Initial Maintenance Term</u>”) will continue until the end of the initial
      maintenance period You purchased in Your Order, unless this Agreement is terminated earlier in
      accordance with its terms, including without limitation, Your failure to pay the then-current
      Maintenance Fee (as defined below) when due. Upon expiration of Your Initial Maintenance Term,
      unless the parties agree to auto-renewal in an Order, your maintenance term will renew for
      additional successive terms upon the mutual written agreement of the parties (each a “
      <u>Renewal Maintenance Term</u>”).
    </div>
    <div id="ww703416" className={'Body'}>
      In the event You wish to renew these Maintenance Program Terms after termination, LiveAction
      shall, as a condition of renewal after termination, charge a reinstatement fee (not to exceed
      half of the then-applicable Maintenance Fee) in addition to the Maintenance Fee; and for
      requests to renew the Maintenance Program Terms thereafter, LiveAction may in its discretion
      refuse renewal. In addition, LiveAction may elect at any time to not renew these Maintenance
      Program Terms in the event LiveAction generally ceases providing support and maintenance
      services for the Software to its customers.
    </div>
    <div id="ww703417" className={'Body'}>
      <b>SUPPORT AND MAINTENANCE SERVICES FOR ON-PREM SOFTWARE</b>
    </div>
    <div id="ww703418" className={'Body'}>
      LiveAction will provide to You during the term of these Maintenance Program Terms (as they may
      be renewed) the following support and maintenance services with respect to the Software and
      the Hardware (if any):{' '}
    </div>
    <div id="ww703419" className={'Bullet'}>
      <span className={'WebWorks_Number'}>
        <span className={'Bullet'}>• </span>
      </span>
      Maintenance Revisions that are generally made available by LiveAction to its On-Prem Software
      customers who have contracted to receive support and maintenance services from LiveAction, as
      such Maintenance Revisions become available, but not including platform extensions or product
      extensions to different hardware platforms or different windowing system platforms or
      different operating system platforms not listed in the Software&apos;s specifications in the
      Documentation;{' '}
    </div>
    <div id="ww703420" className={'Bullet'}>
      <span className={'WebWorks_Number'}>
        <span className={'Bullet'}>• </span>
      </span>
      Updates to Documentation as may from time-to-time become available;
    </div>
    <div id="ww703421" className={'Bullet'}>
      <span className={'WebWorks_Number'}>
        <span className={'Bullet'}>• </span>
      </span>
      Technical Support – Please visit{' '}
      <span className={'xref'}>
        <a href="https://liveaction.com/support/technical-support/" target="external_window">
          https://liveaction.com/support/technical-support/
        </a>
      </span>{' '}
      for technical support trouble ticket submissions and current phone number, or email
      LiveAction&apos;s Technical Support at{' '}
      <span className={'xref'}>
        <a href="mailto:support@liveaction.com" target="external_window">
          support@liveaction.com
        </a>
      </span>
      . Normal business hours during which LiveAction will provide technical support are posted on
      LiveAction&apos;s website.
    </div>
    <div id="ww703422" className={'Body'}>
      LiveAction&apos;s obligations to provide the foregoing services are subject to Your:{' '}
    </div>
    <div id="ww703423" className={'Bullet'}>
      <span className={'WebWorks_Number'}>
        <span className={'Bullet'}>• </span>
      </span>
      Promptly providing notice to LiveAction&apos;s designated email address of any bugs or
      apparent programming error You become aware of;
    </div>
    <div id="ww703424" className={'Bullet'}>
      <span className={'WebWorks_Number'}>
        <span className={'Bullet'}>• </span>
      </span>
      Providing LiveAction with such information as it may reasonably request to identify and
      replicate the bug or error, such as error diagnostic messages, diagnostic memory dumps,
      operator console logs, data file dumps, application Software listings, and a written
      explanation of the problem; and
    </div>
    <div id="ww703425" className={'Bullet'}>
      <span className={'WebWorks_Number'}>
        <span className={'Bullet'}>• </span>
      </span>
      Using reasonable efforts before contacting LiveAction to resolve the error if it is not
      clearly related to an error in the Software. Such efforts will include, as appropriate: (1) a
      technical analyst attempting to resolve end user issues based on personal knowledge or
      investigation; and (2) diagnostic investigation to define, isolate, and resolve the suspected
      error.
    </div>
    <div id="ww703426" className={'Body'}>
      The Maintenance Program does not cover any support or maintenance of Hardware vendor operating
      systems and other host system software, including Your own or third-party software.{' '}
    </div>
    <div id="ww703427" className={'Body'}>
      <b>PERPETUAL ON-PREM LICENSE - MAINTENANCE FEE</b>
    </div>
    <div id="ww703428" className={'Body'}>
      If You have purchased a Perpetual On-Prem License, You agree to pay to LiveAction or the
      respective authorized LiveAction reseller (as applicable) Maintenance Fees for the provision
      of the maintenance and technical support services in accordance with this Exhibit A. The
      annual Maintenance Fees shall be as per Your Order or as otherwise communicated to You by
      LiveAction from time to time at the beginning of the applicable Initial Maintenance Term or
      any Renewal Maintenance Term.
    </div>
    <div id="ww703430" className={'Body'}>
      <b>SUPPORT AND MAINTENANCE SERVICES FOR SAAS SOFTWARE</b>
    </div>
    <div id="ww703432" className={'Body'}>
      LiveAction will provide to You during the term of Your SaaS License the following support and
      maintenance services:
    </div>
    <div id="ww703434" className={'Bullet'}>
      <span className={'WebWorks_Number'}>
        <span className={'Bullet'}>• </span>
      </span>
      LiveAction will regularly push Maintenance Revisions for SaaS Software to its SaaS Software
      customers, and such Maintenance Revisions are included in the Fees for the SaaS License;
    </div>
    <div id="ww703435" className={'Bullet'}>
      <span className={'WebWorks_Number'}>
        <span className={'Bullet'}>• </span>
      </span>
      Updates to Documentation as may from time-to-time become available;
    </div>
    <div id="ww703436" className={'Bullet'}>
      <span className={'WebWorks_Number'}>
        <span className={'Bullet'}>• </span>
      </span>
      Technical Support – Please visit{' '}
      <span className={'xref'}>
        <a href="https://liveaction.com/support/technical-support/" target="external_window">
          https://liveaction.com/support/technical-support/
        </a>
      </span>{' '}
      for technical support trouble ticket submissions and current phone number, or email
      LiveAction&apos;s Technical Support at{' '}
      <span className={'xref'}>
        <a href="mailto:support@liveaction.com" target="external_window">
          support@liveaction.com
        </a>
      </span>
      . Normal business hours during which LiveAction will provide technical support are posted on
      LiveAction&apos;s website.
    </div>
    <div id="ww703439" className={'Title'}>
      EXHIBIT B<br />
      EVALUATION LICENSE TERMS &amp; CONDITIONS{' '}
    </div>
    <div id="ww703441" className={'Body'}>
      These terms and conditions govern in the event You wish to evaluate certain LiveAction
      Software, Hardware and/or related Documentation and materials (collectively, the “
      <b>Evaluation Products</b>”) as a proof of concept in a non-commercial, non-production
      environment (the “<b>Evaluation</b>”).
    </div>
    <div id="ww703442" className={'Step1'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>1. </span>
      </span>
      Evaluation License.{' '}
    </div>
    <div id="ww703443" className={'StepAlpha1'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>a. </span>
      </span>
      The Evaluation will continue for a period of 60 calendar days from the date LiveAction ships
      the relevant Evaluation Products to You, or the date You first access or download the
      Evaluation Products (the “<u>Evaluation Period</u>”), and the Evaluation Period may be
      extended only in writing (email sufficient) at LiveAction&apos;s sole discretion.{' '}
    </div>
    <div id="ww703444" className={'StepAlpha1'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>b. </span>
      </span>
      LiveAction grants to You a limited, personal, non-exclusive, nontransferable,
      non-sublicenseable, evaluation license and right to use the Evaluation Products, free of
      charge, upon Your request and for one time only, for the Evaluation Period and solely for Your
      internal evaluation of the Evaluation Products&apos; suitability for Your business needs. You
      will have no right under the Agreement, including under this Exhibit B, to use the Evaluation
      Products for production, development, commercial use or any other purpose not specifically set
      forth herein.
    </div>
    <div id="ww703445" className={'StepAlpha1'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>c. </span>
      </span>
      You are responsible for all of Your own costs and expenses associated with the use and
      maintenance of the Evaluation Products evaluated in the course of the Evaluation and the
      performance of all testing and evaluation activities.
    </div>
    <div id="ww703446" className={'StepAlpha1'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>d. </span>
      </span>
      LiveAction provides the Hardware, if any, to You for the Evaluation Period. In the event that
      the Hardware includes or incorporates any software code (including without limitation any
      firmware, operating system or other software), such software code shall be deemed “Software”
      licensed to You solely under the terms of this Exhibit B. The Hardware is loaned, not sold to
      You. You shall keep the Hardware free of all security interests, liens and other encumbrances.
      You shall not sell, lease, sublicense, assign or otherwise transfer, export or dispose of the
      Hardware. You will use reasonable care in the use of the Hardware and protect the Hardware
      from theft, damage or misuse. You assume the entire risk of loss, damage, or theft of the
      Hardware while in Your possession. You shall not, and shall not allow others to, reverse
      engineer, de-compile or disassemble the Hardware, or otherwise attempt to discover any
      underlying proprietary or confidential information. You will use the Hardware solely in
      connection with the Software and in technical configuration specified by LiveAction.{' '}
    </div>
    <div id="ww703447" className={'StepAlpha1'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>e. </span>
      </span>
      <b>
        Notwithstanding anything to the contrary herein: (i) LiveAction shall have no obligation
        under this Agreement or otherwise to provide any maintenance or support services with
        respect to the Evaluation Products; and (ii) LiveAction shall have no obligations to
        indemnify or otherwise defend You under this Agreement with respect to the Evaluation
        Version; and (iii) Sections 7, 12 and 15 of the main body of the Agreement (the “Main
        Agreement”) shall not apply with respect to the Evaluation Products.
      </b>
    </div>
    <div id="ww703448" className={'StepAlpha1'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>f. </span>
      </span>
      Following the end of the Evaluation Period, Your Evaluation License may be converted into a
      Subscription On-Prem License, Perpetual On-Prem License or SaaS License (as applicable) upon
      execution of a Quote or Order, Your payment of the applicable Fees and Your agreement with the
      then-current version of the Agreement in effect at the time.
    </div>
    <div id="ww703449" className={'StepAlpha1'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>g. </span>
      </span>
      The Evaluation may be terminated immediately upon notice from LiveAction in its sole
      discretion.
    </div>
    <div id="ww703450" className={'StepAlpha1'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>h. </span>
      </span>
      Except to the extent such terms conflict with the specific Evaluation License Terms and
      Conditions set forth in this Exhibit B, all other terms of the Agreement shall apply to Your
      use of the Services during the Evaluation.
    </div>
    <div id="ww703452" className={'Step'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>2. </span>
      </span>
      <b>Intellectual Property Rights &amp; Ownership</b>. LiveAction and its licensors or suppliers
      own and retain all right, title and interest, including all copyrights, patents, trade secret
      rights, trademarks, and other intellectual property rights, in and to the Evaluation Products.
      You shall keep the Products free and clear of all claims, liens and legal processes of Your
      creditors, or any other party claiming through You.
    </div>
    <div id="ww703453" className={'Step'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>3. </span>
      </span>
      <b>Termination</b>.
    </div>
    <div id="ww703454" className={'StepAlpha1'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>a. </span>
      </span>
      Notwithstanding anything to the contrary herein, upon the expiration or termination of the
      Evaluation, (i) You shall return to LiveAction all copies of any Software Evaluation Products,
      LiveAction&apos;s Confidential Information, and destroy all electronic copies of any of the
      foregoing in Your possession and certify to LiveAction in writing that You have done so; and
      (ii) if You do not choose to enter into a license for Software following the Evaluation, You
      will, within ten (10) days of the end of the Evaluation Period and at Your expense, return any
      such Hardware Evaluation Products to LiveAction in the same condition as when delivered to
      You, reasonable wear and tear excepted. All such Evaluation Products are to be returned in the
      original packing material. If any such Hardware is not returned to LiveAction in the condition
      set forth above within ten (10) days of the expiration or termination of the Evaluation
      Period, LiveAction will charge You and You shall pay for the Hardware Evaluation Products at
      full undiscounted and then-current list price.
    </div>
    <div id="ww703455" className={'StepAlpha1'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>b. </span>
      </span>
      Sections 2 through 6 of this Exhibit B will survive termination or expiration of the
      Evaluation and the Agreement.
    </div>
    <div id="ww703456" className={'Step'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>4. </span>
      </span>
      <b>Disclaimer; No Warranty</b>. THE EVALUATION PRODUCTS AND THE CONFIDENTIAL INFORMATION ARE
      PROVIDED ON AN “AS IS,” “AS AVAILABLE” BASIS, WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED
      AND LIVEACTION AND ITS RESELLERS, SUPPLIERS AND LICENSORS DISCLAIM ALL WARRANTIES EXPRESS OR
      IMPLIED, INCLUDING, WITHOUT LIMITATION, THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR
      A PARTICULAR USE, AND NON-INFRINGEMENT.{' '}
    </div>
    <div id="ww703457" className={'Step'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>5. </span>
      </span>
      <b>LIMITATION OF LIABILITY</b>. TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT
      SHALL THE LIVEACTION PARTIES (AS DEFINED IN THE MAIN AGREEMENT) BE LIABLE FOR ANY SPECIAL,
      INCIDENTAL, INDIRECT, OR CONSEQUENTIAL DAMAGES WHATSOEVER (INCLUDING, WITHOUT LIMITATION,
      DAMAGES FOR LOSS OF PROFITS, LOSS OF REVENUE, LOSS OF INFORMATION, LOSS OF DATA, LOSS OF
      GOODWILL, BUSINESS INTERRUPTION OR WORK STOPPAGE, COMPUTER FAILURE, MALFUNCTION, OR BUSINESS
      INTERRUPTION) ARISING OUT OF THE USE OF OR INABILITY TO USE THE EVALUATION PRODUCTS, EVEN IF
      THE LIVEACTION PARTY(IES)HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES AND
      NOTWITHSTANDING THE FAILURE OF ESSENTIAL PURPOSE OF ANY LIMITED REMEDY PROVIDED HEREUNDER. TO
      THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, THE MAXIMUM CUMULATIVE LIABILITY, AND THE
      MAXIMUM CUMULATIVE REMEDY YOU MAY RECOVER FROM THE LIVEACTION PARTIES (AS DEFINED IN THE MAIN
      AGREEMENT) IN CONNECTION WITH AN EVALUATION SHALL BE LIMITED TO $100.{' '}
    </div>
    <div id="ww703458" className={'Step'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>6. </span>
      </span>
      <b>Partnership; Obligations</b>. Neither the discussions taking place between the parties nor
      the exchange of material or information shall be deemed to create any partnership, agency or
      other relationship, between the parties or to create or impose on either party an obligation
      to enter into any other agreement with the other party or prohibit either party from entering
      into discussions and agreements with third parties except as otherwise provided herein.
    </div>
    <div id="ww703460" className={'Title'}>
      EXHIBIT C<br />
      SERVICE LIMITS AND OVER-SUBSCRIBED SITUATIONS
    </div>
    <div id="ww703461" className={'Step1'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>1. </span>
      </span>
      The inbound volume of Your Data is averaged and assessed every 1 hour.
    </div>
    <div id="ww703463" className={'Step'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>2. </span>
      </span>
      Sustained one-hour periods of inbound data traffic in excess of the Subscribed Volume as set
      forth on Your Order is deemed a “burst”.
    </div>
    <div id="ww703465" className={'Step'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>3. </span>
      </span>
      Bursts that are less than 20% above Your Subscribed Volume are considered normal bursts.
    </div>
    <div id="ww703466" className={'StepAlpha1'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>a. </span>
      </span>
      More than ten normal burst periods over a seven-day period is deemed an “Over-Subscribed
      Situation.”
    </div>
    <div id="ww703467" className={'StepAlpha1'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>b. </span>
      </span>
      You will be notified of the Over-Subscribed Situation and given 30 days to cure by either:
    </div>
    <div id="ww703468" className={'StepAlphai'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>i. </span>
      </span>
      Reducing Your inbound data volume; or
    </div>
    <div id="ww703469" className={'StepAlphai'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>ii. </span>
      </span>
      Purchasing more capacity
    </div>
    <div id="ww703470" className={'StepAlpha1'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>c. </span>
      </span>
      LiveAction reserves the right to suspend inbound flows of Your Data after 30 days if the
      Over-Subscribed Situation is not remedied during such notice period. LiveAction shall have no
      liability for any data flows that You initiate but which are not received by LiveAction in
      connection with an Over-Subscribed Situation or Your suspension.
    </div>
    <div id="ww703473" className={'Step'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>4. </span>
      </span>
      Bursts that are more than 20% above Your Subscribed Volume are “extreme bursts”.
    </div>
    <div id="ww703474" className={'StepAlpha1'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>a. </span>
      </span>
      Any extreme burst will be deemed an Over-Subscribed Situation.{' '}
    </div>
    <div id="ww703475" className={'StepAlpha1'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>b. </span>
      </span>
      You will be notified of the Over-Subscribed Situation.{' '}
    </div>
    <div id="ww703476" className={'StepAlpha1'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>c. </span>
      </span>
      LiveAction reserves the right to suspend inbound flows of Your Data immediately upon notice
      (no cure period). LiveAction shall have no liability for any data flows that You initiate but
      which are not received by LiveAction in connection with an Over-Subscribed Situation or Your
      suspension.
    </div>
    <div id="ww703481" className={'Title'}>
      EXHIBIT D<br />
      SERVICE LEVEL AGREEMENT
    </div>
    <div id="ww703483" className={'Body'}>
      This is Exhibit D - Service Level Agreement (“SLA”) for SaaS Software to the Software License
      and Maintenance Agreement (“Agreement”) between LiveAction, Inc. and You. Capitalized terms
      defined in this SLA shall have the meanings ascribed to them herein. Capitalized terms used in
      this SLA but not defined herein, shall have the meanings ascribed to them in the Agreement.
    </div>
    <div id="ww703484" className={'Step1'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>1. </span>
      </span>
      <b>Definitions</b>.
    </div>
    <div id="ww703485" className={'IndentBlock1'}>
      “
      <u>
        <i>Availability Percentage</i>
      </u>
      <i>”</i> means:
    </div>
    <div id="ww703486" className={'IndentBlock2'}>
      ((N minus O) divided by N) times 100
    </div>
    <div id="ww703487" className={'IndentBlock2'}>
      where
    </div>
    <div id="ww703488" className={'IndentBlock2'}>
      “N” is the total number of hours in any Month minus Excluded Downtime;{' '}
    </div>
    <div id="ww703489" className={'IndentBlock2'}>
      and{' '}
    </div>
    <div id="ww703490" className={'IndentBlock2'}>
      “O” is the total number of hours or portions thereof in any Month, other than Excluded
      Downtime, that the SaaS Software is not accessible by You.{' '}
    </div>
    <div id="ww703492" className={'IndentBlock1'}>
      <i>“</i>
      <u>
        <i>Excluded Downtime</i>
      </u>
      <i>” </i>means the total number of hours or portions thereof in a Month of (i) Scheduled
      Maintenance, (ii) Emergency Maintenance, (iii) downtime caused by errors or failures in
      equipment, the Internet and other networks not within LiveAction&apos;s control, and (iv)
      downtime caused by Your exceeding Your Service Limits.
    </div>
    <div id="ww703494" className={'IndentBlock1'}>
      <i>“</i>
      <u>
        <i>LiveAction Support Hours</i>
      </u>
      <i>” </i>means 8 hours per day, 5 days per week, 52 weeks per year (except for US federal
      holidays), and 24 hours per day, 7 days per week for Priority 1 Issues.
    </div>
    <div id="ww703496" className={'IndentBlock1'}>
      <i>“</i>
      <u>
        <i>Month</i>
      </u>
      <i>”</i> means a calendar month.
    </div>
    <div id="ww703498" className={'IndentBlock1'}>
      <i>“</i>
      <u>
        <i>Service Credit</i>
      </u>
      <i>”</i> shall mean the credit issued for a Service Outage as set forth below in Section 3.
    </div>
    <div id="ww703500" className={'IndentBlock1'}>
      <i>“</i>
      <u>
        <i>Service Outage</i>
      </u>
      <i>”</i> shall mean an event where LiveAction has failed to meet the Service Level in Section
      2(a) below.
    </div>
    <div id="ww703502" className={'Step'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>2. </span>
      </span>
      <b>Service Level</b>.
    </div>
    <div id="ww703503" className={'StepAlpha1'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>a. </span>
      </span>
      <b>Service Level</b>. LiveAction warrants: (i) that the Availability Percentage of the SaaS
      Software shall be at least 99.95% during each Month (&quot;Service Level&quot;): and (ii) the
      functionality or features of the SaaS Software may change but will not materially decrease
      during any paid term. The warranties in this SLA apply solely to Your use of the SaaS Software
      within Your permitted Service Limits.
    </div>
    <div id="ww703504" className={'StepAlpha1'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>b. </span>
      </span>
      <b>Scheduled Maintenance</b>. LiveAction may schedule downtime or periods when the SaaS
      Software will be unavailable so as to improve, repair or otherwise maintain the SaaS Software
      (“
      <u>
        <i>Scheduled Maintenance</i>
      </u>
      ”). LiveAction will make commercially reasonable efforts to notify Your designated point of
      contact by phone or email at least one (1) week in advance of upgrades, maintenance and other
      planned activities that may result in an interruption in the SaaS Software. LiveAction will
      use commercially reasonable efforts to ensure all such Scheduled Maintenance shall: (i) last
      no longer than two hours; (ii) be scheduled during weekend hours or between the hours of 11
      p.m. and 5 a.m. Eastern; and (iii) occur no more frequently than twice/month excluding
      emergency maintenance as detailed in section 2(c); provided that LiveAction may request Your
      approval for extensions of Scheduled Maintenance.
    </div>
    <div id="ww703505" className={'StepAlpha1'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>c. </span>
      </span>
      <b>Emergency Maintenance</b>. On occasion, emergency maintenance may be required to address
      material security-related issues or technical problems that would impact the availability of
      the SaaS Software and resolution of which cannot wait until the next Scheduled Maintenance or
      cannot be remedied in the course of Scheduled Maintenance (“
      <u>
        <i>Emergency Maintenance</i>
      </u>
      ”). LiveAction shall use commercially reasonable efforts to notify Your designated point of
      contact by phone or email at least two (2) hours in advance of any Emergency Maintenance, and
      if possible to post on the SaaS Software an appropriate message, where possible, but in any
      event shall promptly notify You of the Emergency Maintenance and actions being taken in the
      course thereof once LiveAction becomes aware of an occasion requiring Emergency Maintenance.
    </div>
    <div id="ww703506" className={'Step'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>3. </span>
      </span>
      <b>Service Credits</b>.
    </div>
    <div id="ww703507" className={'StepAlpha1'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>a. </span>
      </span>
      <b>Service Credit Amount</b>. In the event that the Availability Percentage for a Month falls
      below the Service Level set forth in Section 2(a) of this SLA, then a Service Outage will have
      occurred and You, within 30 days of the end of the applicable Month, may request a Service
      Credit equal to 1% of the Month&apos;s subscription fee for the affected Service for each 1%
      by which the Availability Percentage falls below the Service Level. The maximum amount of the
      Service Credit is 50% of the monthly subscription fee.
    </div>
    <div id="ww703508" className={'StepAlpha1'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>b. </span>
      </span>
      <b>Claims for Service Credit</b>. Any claims for a Service Credit shall be made by You to
      LiveAction&apos;s customer support organization by email to support@liveaction.com. LiveAction
      will investigate the claim and will endeavor to respond back to You within fourteen (14) days
      of receipt of the notification of a claim from You, either (i) accepting Your Service Outage
      claim, or (ii) with details and documentation supporting a dispute of Your Service Outage
      claim, in which case the parties shall resolve any such dispute promptly in good faith.
      Service Credits obtained by You shall have no cash value but will apply as set forth herein
      against future invoices. Credits will not apply to any other form of Services provided by
      LiveAction. Your sole and exclusive remedy, and LiveAction&apos;s sole and exclusive
      liability, in the event of a Service Outage, shall be to receive the Service Credits in
      accordance with the terms of this SLA.
    </div>
    <div id="ww703511" className={'Step'}>
      <span className={'WebWorks_Number'}>
        <span className={'Step_0023'}>4. </span>
      </span>
      <b>Severity Definitions, Escalations and Procedures</b>. LiveAction shall provide Support
      Services in accordance with the severity escalations and procedures set forth at{' '}
      <span className={'xref'}>
        <a href="https://www.liveaction.com/support/technical-support/" target="external_window">
          https://www.liveaction.com/support/technical-support/
        </a>
      </span>
      .
    </div>
    <div id="ww703296" className={'Body'}>
      &nbsp;
    </div>
    <div id="ww701764" className={'Body'}>
      © 2022 LiveAction, Inc.{' '}
    </div>
    <div id="ww701634" className={'Body'}>
      &nbsp;
    </div>
  </ProductLayout>
)

export default TermsPage
